import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-broadcastings-tv-format-resume-card',
  templateUrl: './broadcastings-tv-format-resume-card.component.html',
  styleUrls: ['./broadcastings-tv-format-resume-card.component.scss']
})
export class BroadcastingsTvFormatResumeCardComponent implements OnInit {

  @Input() tvFormatDevice;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../../tvformat', this.tvFormatDevice.InternalId], { relativeTo: this.activatedRoute });
    }
  }

  public getColor() {
    switch (this.tvFormatDevice.Status) {
      case 'ONLINE':
        return 'success';
      case 'OFFLINE':
        return 'error';
      case 'WAITING_UPDATE':
        return 'warning';
    }
  }

  public getStatus() {
    if (this.tvFormatDevice) {
      switch (this.tvFormatDevice.Status) {
        case 'ONLINE':
          return 'online';
        case 'WAITING_UPDATE':
          return 'waiting';
        case 'OFFLINE':
          return 'offline';
        default:
          return 'offline';
      }
    }
  }
}
